module.exports = __webpack_public_path__ + "img/笑脸.f99136ce.png";